import http from './http';

type RegisterProps = {
  email: string;
  password: string;
}

const register = (data: RegisterProps) => http.post('/register', data);

const auth = (data: RegisterProps) => http.post('/auth', data)
  .then((response) => {
    localStorage.setItem('user', response.data.id);
    localStorage.setItem('user2', response.data.token);
  });

const logout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('user2');
  window.location.reload();
};

const uploadFile = (cardId: number, file: any, fieldId: number) => {
  const data = new FormData();
  data.append(fieldId.toString(), file);

  return http.post(`/card/${cardId}/files`, data);
};

const getSpecialities = () => http.get('/specialities');

const getFields = () => http.get('/fields');

const isAuth = () => !!localStorage.getItem('user');

const isLocal = () => !!localStorage.getItem('local');

const save = (cardId: number, fields: any[], specialities: any[]) => http.post(`/card/${cardId}/fields`, { fields, specialities });

const CardService = {
  auth,
  getFields,
  getSpecialities,
  isAuth,
  isLocal,
  logout,
  register,
  save,
  uploadFile,
};

export default CardService;
